<template>

       <div class="row mb-4">
            <div class="col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title mb-4">Point of Interest Twitter
                  </h5>
                  <div class="table-responsive mb-0" v-if="!loading_twitter">
                    <table class="table table-nowrap table-centered table-hover">
                      <tbody>
                        <tr v-for="tw in twitter" :key="tw.id_twitter">
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img :src="tw.avatar" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link :to="{ name: 'twitter-view', params: { id: tw.account }}" class="text-primary">{{tw.name}} 
                              <span><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px" v-if="tw.verified"></i></span></router-link>
                            </h5>
                            <small>@{{tw.account}}</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="loading_twitter" class="mt-5 mb-5 pt-5 mx-auto text-center">
                    <div class="text-center mt-4">
                        <b-spinner label="Loading..."></b-spinner>
                        <br> loading..
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title mb-4">Point of Interest Instagram</h5>
                  <div class="table-responsive mb-0" v-if="!loading_instagram">
                    <table class="table table-nowrap table-centered table-hover">
                      <tbody>
                        <tr v-for="ig in instagram" :key="ig.id_instagram">
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                                <img
                                  :src="avatar+ig.picture"
                                  class="mr-3 rounded-circle"
                                  alt="ig" v-if="ig.picture_hd"
                                  width="100%"
                                  />   
                                <img :src="ig.picture" alt="ig" class="mr-3 rounded-circle" v-if="ig.picture && !ig.picture_hd" width="100%">
                                <img
                                  src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                                  class="mr-3 rounded-circle"
                                  alt="ig" v-if="!ig.picture && !ig.picture_hd"
                                  width="100%"
                                  />
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                                  <router-link :to="{ name: 'instagram-view', params: { id: ig.account }}" class="text-primary">{{ig.full_name}} <span><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span></router-link>
                            </h5>
                            <small>@{{ig.account}}</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="loading_instagram" class="mt-5 mb-5 pt-5 mx-auto text-center">
                    <div class="text-center mt-4">
                          <b-spinner label="Loading..."></b-spinner>
                          <br> loading..
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title mb-4">Point of Interest Group Telegram</h5>
                  <div class="table-responsive mb-0" v-if="!loading_telegram">
                    <table class="table table-nowrap table-centered table-hover">
                      <tbody>
                        <tr v-for="tele in telegram" :key="tele.id">
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img :src="avatar_tele+tele.username+'&path=media/telegram/'+tele.username"  class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link :to="{ name: 'group-view', params: { id: tele.username }}" class="text-primary">{{tele.title}}</router-link>
                            </h5>
                            <small>@{{tele.username}}</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                       
                      </tbody>
                    </table>
                  </div>
                  <div v-if="loading_telegram" class="mt-5 mb-5 pt-5 mx-auto text-center">
                    <div class="text-center mt-4">
                          <b-spinner label="Loading..."></b-spinner>
                          <br> loading..
                    </div>
                  </div>
                </div>
              </div>
            </div>
       </div>
</template>

<script>
import TwintService from "@/helpers/twint.service.js";
import appConfig from "@/app.config";
import store from '@/state/store';
import moment from 'moment';
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
import GroupService from "@/helpers/group.service.js";
import PreferenceService from "@/helpers/preference.service.js";
// import { tableData } from "./dataAdvancedtable";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT+'stream-profil/?name=',
      avatar_tele: process.env.VUE_APP_BASE_API_URL_OSINT+'stream-img/?name=',
      twitter: [],
      elastic:"",
      instagram: [],
      telegram: [],
      loading_twitter: false,
      loading_instagram: false,
      loading_telegram: false,
    };
  },
  methods:{
    listTwitter(){
      this.loading_twitter = true;
      SocmedService.getAllTwitter()
      .then(response => {
                this.twitter = []
                  response.data.data.forEach((val, index) => {
                    const data = {    
                    "no" : index+1,
                    "id_twitter" : val.id_twitter,
                    "user_id" : val.user_id,
                    "account" : val.account,
                    "name" : val.name,
                    "verified" : val.is_verified,
                    "avatar" : val.avatar,
                    "followers" : val.followers,
                    "following" : val.following,
                    "tweets" : val.tweets,
                    "join_at" : val.join_at,
                    "pin" : val.pin,
                    }
                    
                    if(val.pin){
                        this.twitter.push(data);
                    }

                    this.loading_twitter = false;
                });
            })
            .catch(err => {
                console.log(err);
                this.loading_twitter = false;
        });
    },

     listInstagram(){
          this.loading_instagram = true,
          SocmedService.getAllInstagram()
          .then(response => {
                    this.instagram = []
                    this.totalAccount = response.data.data.length;
                    response.data.data.forEach((val, index) => {
                        const data = { 
                        "no" : index+1, 
                        "id_instagram" : val.id_instagram,
                        "user_id" : val.user_id,
                        "account" : val.account,
                        "full_name" : val.full_name,
                        "verified" : val.is_verified,
                        "picture" : val.picture,
                        "picture_hd" : val.picture_hd,
                        "followers" : val.followers,
                        "following" : val.following,
                        "media" : val.media,
                        "pin" : val.pin,
                        }
                        
                        if(val.pin){
                            this.instagram.push(data);
                        }
                        this.loading_instagram = false;
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.loading_instagram = false;
            });
        },

    groupList() {
      var name = 'telegram';
      this.loading_telegram = true;
        GroupService.getTelegramGroupElastic(this.elastic, name)
        .then((response) => {
          console.log("response => ", response.data);
              this.telegram = [];
              this.created_at_grouplist = response.data._source.created_at;
                response.data._source.listgroup.forEach(val => {
                    const data = {    
                        "id" : val.id,
                        "title" : val.title,
                        "username" : val.username,
                        "participants_count" : val.participants_count,
                        "about" : val.about,
                        "message" : val.message,
                        "pin" : val.pin,
                    }
                    if(val.pin){
                        this.telegram.push(data);
                    }
                    this.loading_telegram = false;  
              });
            })
            .catch(err => {
              if(err == "Error: Request failed with status code 404"){
                    this.groupList();
                } else {
                    console.log(err);
                    this.loading_telegram = false; 
                }
          });
    },

    //   groupList() {
    //     GroupService.listGroupTelegram(this.elastic)
    //     .then((response) => {
    //       console.log("response => ", response.data.hits.hits);
    //           this.telegram = [];
    //           // this.created_at_grouplist = response.data._source.created_at;
    //             response.data.hits.hits.forEach((val, index) => {
    //                 const data = {  
    //                 "no" : index+1,  
    //                 "id" : val._source.id,
    //                 "title" : val._source.title,
    //                 "username" : val._source.username,
    //                 // "account" : val._source.account,
    //                 "participants_count" : val._source.participants_count,
    //                 "about" : val._source.about,
    //                 "broadcast" : val._source.message,
    //                 "pin" : val._source.pin,
    //                 }
    //                 if(val._source.pin){
    //                     this.telegram.push(data);
    //                 }
    //                 this.loading = false;  
    //           });
    //         })
    //         .catch(err => {
    //           if(err == "Error: Request failed with status code 404"){
    //                 this.groupList();
    //             } else {
    //                 console.log(err);
    //                 this.loading = false; 
    //             }
    //       });
    // },

    getPreferences(){
       this.loading_telegram = true;
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.groupList();
        })
        .catch((err) => {
            console.log(err);
            this.loading = false;
        });
    },

  },
  mounted(){
    this.listTwitter();
    this.listInstagram();
    this.getPreferences();
  }
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
/* .my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
} */
</style>